import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleAvailableCohortReportsQuery } from "../store/api/core";
import { FilterContext, updateFilters } from "../providers/FilterProvider";
import { AvailableFilters, getEntity } from "../common/filters";
export var useCohortAssessmentCategoryFilter = function () {
    var _a;
    var _b, _c;
    var reportId = useParams().reportId;
    var getFilters = useContext(FilterContext).getFilters;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    }, { shouldSkipCall: function () { return !reportId; } });
    var assessmentCategory = (reportData.data || {}).assessmentCategory;
    if (((_c = (_b = getFilters()) === null || _b === void 0 ? void 0 : _b[getEntity(AvailableFilters.AssessmentCategory)]) === null || _c === void 0 ? void 0 : _c[0]) !=
        assessmentCategory) {
        updateFilters((_a = {},
            _a[getEntity(AvailableFilters.AssessmentCategory)] = [assessmentCategory],
            _a));
    }
};
